import SfSelectorMobileBg from '@/assets/images/generator/sf-selector-mobile-bg.png';
import { CloseFilledIcon } from '@/components/Icons';
import StyleFilterList from './StyleFilterList';
import { useEffect, useState } from 'react';
import { useGeneratorFilterStore } from '@/state/generator-filter-store';
import StyleFilterDetail from './StyleFilterDetail';
import { useController } from 'react-hook-form';
import useGeneratorStore from '@/state/generator-store';
import { FilterGroup } from '@/service/type/Filter';

interface MobileStyleFilterProps {
  close: () => void;
}

const MobileStyleFilter = ({ close }: MobileStyleFilterProps) => {
  const [filterDetail, setShowFilterDetail] = useState<FilterGroup | null>(null);
  const { currentFilterGroup, setCurrentFilterGroup } = useGeneratorFilterStore();
  useEffect(() => {
    if (currentFilterGroup) {
      setShowFilterDetail(currentFilterGroup);
    }
  }, []);

  const { control, formValues, setIsGeneratorDrawerShow } = useGeneratorStore((state) => ({
    control: state.control,
    formValues: state.formValues,
    setIsGeneratorDrawerShow: state.setIsGeneratorDrawerShow,
  }));
  const {
    field: { onChange: setStyleFilterId, value: styleFilterId },
  } = useController({
    name: 'styleFilterId',
    control,
  });

  const {
    field: { onChange: setStyleFilterWeight, value: filterWeight },
  } = useController({
    name: 'filterWeight',
    control,
    defaultValue: formValues?.filterWeight || 0,
  });
  const {
    field: { onChange: onChangeStyleFilterIsOpened },
  } = useController({
    name: 'styleFilterIsOpened',
    control,
  });

  return (
    <div
      className=" relative"
      style={{
        width: 348,
        height: 540,
        backgroundImage: `url(${SfSelectorMobileBg}) `,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        objectFit: 'cover',
        overflow: 'visible',
        marginTop: '60px',
      }}
    >
      <div
        className="absolute gap-[6px] top-[-60px] left-1/2 transform -translate-x-1/2 flex text-[#fff] bg-[#2b2d2f] p-[12px] rounded-full z-10 cursor-pointer"
        onClick={close}
      >
        <CloseFilledIcon fillColor="currentColor" /> Close
      </div>
      <div
        className=" w-[170px]  h-[51px] absolute left-[20px] rounded-b-xl"
        style={{
          border: '1px solid var(--_Lil-Bottom-Highlight, rgba(255, 255, 255, 0.00))',
          borderTop: 0,
          background: 'linear-gradient(180deg,#ee5525, #e3663e)',
          backgroundOrigin: 'border-box',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div
          style={{
            boxShadow:
              '160px -133px 58px 0px rgba(0, 0, 0, 0.00) inset, 102px -85px 53px 0px rgba(0, 0, 0, 0.01) inset, 58px -48px 45px 0px rgba(0, 0, 0, 0.05) inset, 6px -5px 18px 0px rgba(0, 0, 0, 0.10) inset',
          }}
          className="tracking-[-0.48px] w-full h-full flex items-center pl-[16px] text-[#FEFBFA] font-[16px] leading-normal rounded-b-xl bg-[#ff5b27] "
        >
          Filter Library
        </div>
      </div>
      <div className="border-light-bottom  overflow-hidden mt-[72px] ml-[20px]  w-[308px] h-[448px] absolute rounded-lg">
        <div
          className="w-full h-full p-[4px]"
          style={{
            borderRadius: '8px',
            border: '1px solid var(--_Lil-Bottom-Highlight, rgba(255, 255, 255, 0.00))',
            background: 'var(--_Inside-Dark, linear-gradient(0deg, #191A1B 0%, #1E2021 100%))',
            boxShadow:
              '15px 55px 16px 0px rgba(0, 0, 0, 0.00) inset, 9px 35px 14px 0px rgba(0, 0, 0, 0.03) inset, 5px 20px 12px 0px rgba(0, 0, 0, 0.10) inset, 2px 9px 9px 0px rgba(0, 0, 0, 0.17) inset, 1px 2px 5px 0px rgba(0, 0, 0, 0.20) inset',
          }}
        >
          {filterDetail ? (
            <StyleFilterDetail
              onBack={() => {
                setShowFilterDetail(null);
              }}
              onRemove={() => {
                setShowFilterDetail(null);
                setCurrentFilterGroup(null);
                setStyleFilterId(undefined);
                setStyleFilterWeight(undefined);
                onChangeStyleFilterIsOpened(false);
              }}
              onSelect={({ filter, weight }) => {
                setCurrentFilterGroup(filter);
                if (weight === 0) {
                  setStyleFilterId(filter.sf_list[0].id);
                } else {
                  setStyleFilterId(filter.sf_list[1].id);
                }
                setStyleFilterWeight(weight);
                onChangeStyleFilterIsOpened(true);
                close();
                setIsGeneratorDrawerShow(true);
              }}
              filter={filterDetail}
              filterWeight={filterDetail.id === styleFilterId ? filterWeight : 0}
            />
          ) : (
            <StyleFilterList
              onSelect={(filterGroup) => {
                setShowFilterDetail(filterGroup);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default MobileStyleFilter;
